<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
  <div tabindex="0">
    <app-preview-data-wrapper
      [label]="'Numer identyfikacyjny podmiotu'"
      [data]="identyfikator()"
      additionalCssClasses="font-bold"
    ></app-preview-data-wrapper>
  </div>
</div>
